import { ButtonPrimary } from '@/components/button'
import { NotFoundIcon } from '@/components/icons'
import { ROUTE_DASHBOARD } from '@/constants/Routes'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const NotFound = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const [currentTime, setCurrentTime] = useState(10)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(currentTime - 1)
    }, 1000)
    if (currentTime === 0) {
      navigate(ROUTE_DASHBOARD, { relative: 'path', replace: true })
    }
    return () => clearInterval(intervalId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime])

  return (
    <div className="bg-[#F1F6FC] flex flex-1 h-screen items-center justify-center relative">
      <NotFoundIcon className="absolute top-[15%] md:w-[390px] md:h-[208] w-[312px] h-[166px]" />
      <div className="rounded shadow-md bg-white z-10 flex flex-col py-10 px-4 md:px-16">
        <h1 className="text-navy-900 text-4xl font-bold leading-loose text-center">{t('common.oops')}</h1>
        <span className="leading-loose text-center text-[#757895] font-medium">{t('common.venturedPath')}</span>
        <span className="leading-loose text-center text-[#757895] font-medium">
          {t('common.contactSupport')}:{' '}
          <a
            href="https://dupr.zendesk.com/hc/en-us/requests/new?ticket_form_id=26010354856852"
            target="_blank"
            className="text-primary-500"
          >
            support@mydupr.com
          </a>
        </span>
        <span className="leading-loose text-center text-[#757895] font-medium">
          {t('common.redirectedDashboard')} {currentTime} {t('common.seconds')}.
        </span>
        <div className="flex justify-center mt-4">
          <ButtonPrimary
            title={t('common.goBack')}
            className="w-24 !rounded"
            onClick={() => navigate(ROUTE_DASHBOARD, { relative: 'path', replace: true })}
          />
        </div>
      </div>
    </div>
  )
}
